import { componentQrl, inlinedQrl, _jsxQ, _jsxC, Slot } from "@builder.io/qwik";
const FragmentComponent = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxQ("span", null, null, /* @__PURE__ */ _jsxC(Slot, null, 3, "oj_0"), 1, "oj_1");
}, "FragmentComponent_component_T0AypnadAK0"));
export {
  FragmentComponent,
  FragmentComponent as default
};
